import { render, staticRenderFns } from "./TrainingCamps.vue?vue&type=template&id=7949a097&scoped=true&"
import script from "@/scripts/TrainingCamp/TrainingCamps/index.js?vue&type=script&lang=js&"
export * from "@/scripts/TrainingCamp/TrainingCamps/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7949a097",
  null
  
)

export default component.exports